/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8034f3b88cb7a5d5ab7ce49abdcabde4>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "TakeoutFood".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known usages: Food emoji category.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const TakeoutFoodIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.034.526A.75.75 0 0 1 5.75 0H10v1.5H6.301L5.521 4H8.25a.75.75 0 0 1 .747.812L8.815 7h3.935A3.25 3.25 0 0 1 16 10.25V14a2 2 0 0 1-2 2H2.887a2 2 0 0 1-1.991-1.81L.003 4.82A.75.75 0 0 1 .75 4h3.199zM7 14.5h7a.5.5 0 0 0 .5-.5v-1.5h-8V14a.5.5 0 0 0 .5.5M6.5 11h8v-.75a1.75 1.75 0 0 0-1.75-1.75h-4.5a1.75 1.75 0 0 0-1.75 1.75zm-1.437 3.5H2.887a.5.5 0 0 1-.498-.453L1.575 5.5h5.86l-.137 1.642A3.25 3.25 0 0 0 5 10.25V14q0 .26.063.5" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
TakeoutFoodIcon.displayName = 'TakeoutFoodIcon';
var _default = exports.default = TakeoutFoodIcon;